import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { LoadPrivacyPolicy } from '@store/taco/taco.actions';
import { TacoStateModel } from '@store/taco/taco.model';
import { catchError, map, of } from 'rxjs';

export const PrivacyPolicyResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);
  const taco = localStorage.getItem('taco');
  
  if (taco) {
    const isPrivacyAccepted = (JSON.parse(taco) as TacoStateModel).privacyAccepted;
    if (!isPrivacyAccepted) {
      return store.dispatch(new LoadPrivacyPolicy()).pipe(
        map(() => true), // Ensure we always return a boolean (true)
        catchError(() => of(false)) // In case of an error, return false to block navigation
      );
    }
  }
  return of(true); // Return true if privacy is accepted or taco is not found
};

